export default "__VITE_ASSET__aLFD0Ghv__"